import { Button, Grid } from "@mui/material";
import { useDownloadBackup } from "../../../hooks/backup";
import { useEffect } from "react";
import { useLoading } from "../../../components/Loading/useLoading";
import { useSnackbar } from "notistack";

export const BackupsIndex = () => {
  const { setAppLoading } = useLoading();
  const { enqueueSnackbar } = useSnackbar();
  const { downloadBackup, isLoading, isError, error } = useDownloadBackup();

  useEffect(() => {
    if (isError) {
      console.error("Error al descargar el backup:", error);
      enqueueSnackbar("Error al descargar el backup", {
        autoHideDuration: 2000,
        variant: "error",
        anchorOrigin: {
          vertical: "top",
          horizontal: "center",
        },
      });
    }
  }, [isError, error, enqueueSnackbar]);

  useEffect(() => {
    console.log("Backup download loading state:", isLoading);
    setAppLoading(isLoading);
  }, [isLoading, setAppLoading]);

  return (
    <Grid container spacing={0}>
      <Grid
        item
        xs={12}
        sm={12}
        md={3}
        lg={3}
        xl={3}
        sx={{ padding: "10px 30px", height: "100%" }}
        className="center_item"
      >
        <Button
          variant="contained"
          className="btn_system"
          onClick={downloadBackup}
          disabled={isLoading}
        >
          Descargar backup
        </Button>
      </Grid>
    </Grid>
  );
};
